/* ==========================================================================
   MATMAZEL — Ana sayfa bölümleri
   Bağımlılık yok. Her bileşen bir kez tanımlanır; dosya birden fazla
   bölümde çağrılsa da güvenle çalışır.
   ========================================================================== */
(function () {
  if (window.__matmazelLoaded) return;
  window.__matmazelLoaded = true;

  var FREE_SHIPPING_TL = 1500; // Ücretsiz kargo eşiği (TL) — bildirim metni için
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function isTyping(el) {
    if (!el) return false;
    var t = el.tagName;
    return t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT' || el.isContentEditable;
  }

  function formatTL(cents) {
    return new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(Math.round(cents / 100)) + ' TL';
  }

  /* ------------------------------------------------------------------
     1) HERO SLIDER  <mz-hero>
     ------------------------------------------------------------------ */
  if (!customElements.get('mz-hero')) {
    customElements.define('mz-hero', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-mz-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-mz-dot]'));
        this.counter = this.querySelector('[data-mz-count]');
        this.status = this.querySelector('[data-mz-status]');
        this.live = this.querySelector('[data-mz-live]');
        this.index = 0;
        this.total = this.slides.length;
        this.hoverPaused = false;
        this.userPaused = reduceMotion || this.dataset.autoplay === 'false' || !!(window.Shopify && window.Shopify.designMode);
        this.visible = true;
        if (this.total < 2) { this.classList.add('is-single'); this.apply(0, true); return; }

        this.style.setProperty('--mz-hero-dur', (parseFloat(this.dataset.speed) || 6) + 's');

        var self = this;
        this.querySelector('[data-mz-prev]') && this.querySelector('[data-mz-prev]').addEventListener('click', function () { self.go(self.index - 1); });
        this.querySelector('[data-mz-next]') && this.querySelector('[data-mz-next]').addEventListener('click', function () { self.go(self.index + 1); });
        this.querySelector('[data-mz-play]') && this.querySelector('[data-mz-play]').addEventListener('click', function () { self.setUserPaused(!self.userPaused); });
        this.dots.forEach(function (d, i) { d.addEventListener('click', function () { self.go(i); }); });

        // Otomatik geçiş: ilerleme çubuğunun animasyonu bitince sonraki slayt
        this.addEventListener('animationend', function (e) {
          if (e.animationName === 'mz-progress' && !self.isPaused()) self.go(self.index + 1);
        });

        // Fare üstünde / klavye odağında dur
        this.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { self.hoverPaused = true; self.sync(); } });
        this.addEventListener('pointerleave', function () { self.hoverPaused = false; self.sync(); });
        this.addEventListener('focusin', function () { self.hoverPaused = true; self.sync(); });
        this.addEventListener('focusout', function (e) { if (!self.contains(e.relatedTarget)) { self.hoverPaused = false; self.sync(); } });

        // Klavye: ← → (hero ekrandayken), Boşluk (odak hero içindeyken)
        this.onKey = function (e) {
          if (!self.visible || e.altKey || e.ctrlKey || e.metaKey || isTyping(document.activeElement)) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
          else if ((e.key === ' ' || e.code === 'Space') && self.contains(document.activeElement) && document.activeElement.tagName !== 'BUTTON' && document.activeElement.tagName !== 'A') {
            e.preventDefault(); self.setUserPaused(!self.userPaused);
          }
        };
        document.addEventListener('keydown', this.onKey);

        // Ekranda değilken klavye ve zamanlayıcıyı kapat
        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(function (en) { self.visible = en[0].isIntersecting; self.sync(); }, { threshold: 0.3 });
          this.io.observe(this);
        }

        // Mobil kaydırma (swipe)
        var sx = 0, sy = 0;
        this.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        this.addEventListener('touchend', function (e) {
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) self.go(self.index + (dx < 0 ? 1 : -1));
        }, { passive: true });

        this.apply(0, true);
        this.sync();
      }
      disconnectedCallback() {
        document.removeEventListener('keydown', this.onKey);
        this.io && this.io.disconnect();
      }
      isPaused() { return this.userPaused || this.hoverPaused || !this.visible; }
      setUserPaused(v) { this.userPaused = v; this.sync(); }
      sync() {
        var paused = this.isPaused();
        this.classList.toggle('is-paused', paused);
        this.classList.toggle('is-user-paused', this.userPaused);
        var btn = this.querySelector('[data-mz-play]');
        if (btn) btn.setAttribute('aria-label', this.userPaused ? 'Otomatik geçişi başlat' : 'Otomatik geçişi durdur');
        if (this.status) this.status.textContent = reduceMotion ? 'Hareket azaltıldı · otomatik geçiş kapalı' : (this.userPaused ? 'Durduruldu · devam etmek için Boşluk' : '');
      }
      go(i) {
        if (this.total < 2) return;
        this.apply((i + this.total) % this.total, false);
      }
      apply(n, first) {
        var self = this;
        this.index = n;
        this.slides.forEach(function (s, i) {
          var on = i === n;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if ('inert' in s) s.inert = !on;
        });
        this.dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === n);
          d.classList.toggle('is-done', i < n);
          d.setAttribute('aria-selected', i === n ? 'true' : 'false');
          // animasyonu yeniden başlat
          var f = d.querySelector('.mz-hero__fill');
          if (f && i === n) { f.style.animation = 'none'; void f.offsetWidth; f.style.animation = ''; }
        });
        var cur = this.slides[n];
        this.style.setProperty('--mz-hero-panel', cur.dataset.panel || '');
        this.style.setProperty('--mz-hero-ui', cur.dataset.fg || '');
        this.style.setProperty('--mz-hero-ui-m', cur.dataset.panelFg || cur.dataset.fg || '');
        if (this.counter) this.counter.textContent = String(n + 1).padStart(2, '0') + ' / ' + String(this.total).padStart(2, '0');
        if (!first && this.live) this.live.textContent = (n + 1) + '. slayt: ' + (cur.getAttribute('aria-label') || '');
      }
    });
  }

  /* ------------------------------------------------------------------
     2) YATAY KAYDIRICI OKLARI  <mz-carousel>
     Kaydırmayı ele geçirmez; sadece oklar + yerel kaydırma.
     ------------------------------------------------------------------ */
  if (!customElements.get('mz-carousel')) {
    customElements.define('mz-carousel', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.rail = this.querySelector('[data-mz-rail]');
        this.prev = this.querySelector('[data-mz-prev]');
        this.next = this.querySelector('[data-mz-next]');
        if (!this.rail) return;
        var step = function () {
          var first = self.rail.children[0];
          if (!first) return self.rail.clientWidth;
          var gap = parseFloat(getComputedStyle(self.rail).columnGap) || 0;
          return first.getBoundingClientRect().width + gap;
        };
        var behavior = reduceMotion ? 'auto' : 'smooth';
        this.prev && this.prev.addEventListener('click', function () { self.rail.scrollBy({ left: -step(), behavior: behavior }); });
        this.next && this.next.addEventListener('click', function () { self.rail.scrollBy({ left: step(), behavior: behavior }); });
        var ticking = false;
        this.update = function () {
          ticking = false;
          var max = self.rail.scrollWidth - self.rail.clientWidth - 2;
          if (self.prev) self.prev.disabled = self.rail.scrollLeft <= 2;
          if (self.next) self.next.disabled = self.rail.scrollLeft >= max;
        };
        this.rail.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(self.update); } }, { passive: true });
        if ('ResizeObserver' in window) { this.ro = new ResizeObserver(function () { self.update(); }); this.ro.observe(this.rail); }
        this.update();
      }
      disconnectedCallback() { this.ro && this.ro.disconnect(); }
    });
  }

  /* ------------------------------------------------------------------
     3) SHOP THE LOOK  <mz-look>
     ------------------------------------------------------------------ */
  if (!customElements.get('mz-look')) {
    customElements.define('mz-look', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.tabs = Array.from(this.querySelectorAll('[data-mz-tab]'));
        this.tabs.forEach(function (t, i) {
          t.addEventListener('click', function () { self.show(i); });
          t.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
              e.preventDefault(); e.stopPropagation();
              var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + self.tabs.length) % self.tabs.length;
              self.show(n); self.tabs[n].focus();
            }
          });
        });
        this.addEventListener('click', function (e) {
          var hot = e.target.closest('[data-mz-hot]');
          if (hot) { e.preventDefault(); self.toggle(hot); return; }
          if (!e.target.closest('.mz-pop')) self.closeAll();
        });
        this.onDoc = function (e) { if (!self.contains(e.target)) self.closeAll(); };
        this.onEsc = function (e) { if (e.key === 'Escape') self.closeAll(); };
        document.addEventListener('click', this.onDoc);
        document.addEventListener('keydown', this.onEsc);
      }
      disconnectedCallback() { document.removeEventListener('click', this.onDoc); document.removeEventListener('keydown', this.onEsc); }
      show(i) {
        this.closeAll();
        this.tabs.forEach(function (t, j) { t.setAttribute('aria-selected', i === j ? 'true' : 'false'); t.tabIndex = i === j ? 0 : -1; });
        this.querySelectorAll('[data-mz-panel]').forEach(function (p, j) { p.classList.toggle('is-active', i === j); });
        this.querySelectorAll('[data-mz-list]').forEach(function (p, j) { p.classList.toggle('is-active', i === j); });
      }
      toggle(hot) {
        var pop = this.querySelector('#' + hot.getAttribute('aria-controls'));
        var open = hot.getAttribute('aria-expanded') === 'true';
        this.closeAll();
        if (!open && pop) { pop.classList.add('is-open'); hot.setAttribute('aria-expanded', 'true'); }
      }
      closeAll() {
        this.querySelectorAll('.mz-pop.is-open').forEach(function (p) { p.classList.remove('is-open'); });
        this.querySelectorAll('[data-mz-hot][aria-expanded="true"]').forEach(function (h) { h.setAttribute('aria-expanded', 'false'); });
      }
    });
  }

  /* ------------------------------------------------------------------
     Tema editörü: seçilen slayta / görünüme git
     ------------------------------------------------------------------ */
  document.addEventListener('shopify:block:select', function (e) {
    var hero = e.target.closest && e.target.closest('mz-hero');
    if (hero && hero.slides) {
      var i = hero.slides.indexOf(e.target);
      if (i > -1) { hero.setUserPaused(true); hero.go(i); }
    }
    var look = e.target.closest && e.target.closest('mz-look');
    if (look && e.target.hasAttribute('data-mz-panel')) {
      var panels = Array.from(look.querySelectorAll('[data-mz-panel]'));
      look.show(panels.indexOf(e.target));
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var hero = e.target.closest && e.target.closest('mz-hero');
    if (hero && hero.setUserPaused) hero.setUserPaused(false);
  });

  /* ------------------------------------------------------------------
     4) HIZLI SEPETE EKLE  [data-mz-add="VARIANT_ID"]
     ------------------------------------------------------------------ */
  var toastEl, toastTimer;
  function toast(title, sub, isError) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mz-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var b = document.createElement('b'); b.textContent = title; toastEl.appendChild(b);
    if (sub) { var s = document.createElement('span'); s.textContent = sub; toastEl.appendChild(s); }
    toastEl.classList.toggle('is-error', !!isError);
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2800);
  }

  function refreshThemeCart(cart) {
    // Prestige (Maestrooo) temaları bu olaylarla sepet sayacını ve çekmeceyi yeniler
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
    } catch (e) { /* sessiz */ }
    // Tema dışı sayaçlar için yedek
    document.querySelectorAll('[data-mz-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mz-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = parseInt(btn.getAttribute('data-mz-add'), 10);
    if (!id || btn.classList.contains('is-loading')) return;
    var name = btn.getAttribute('data-mz-name') || 'Ürün';
    var label = btn.querySelector('.mz-card__quick-label') || btn;
    var original = label.textContent;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
      .then(function (cart) {
        refreshThemeCart(cart);
        var left = FREE_SHIPPING_TL * 100 - cart.total_price;
        toast(name + ' sepete eklendi', left <= 0 ? 'Ücretsiz kargo kazandınız' : 'Ücretsiz kargoya ' + formatTL(left) + ' kaldı');
        if (label !== btn) { label.textContent = 'Sepete eklendi ✓'; setTimeout(function () { label.textContent = original; }, 1600); }
      })
      .catch(function (err) {
        toast('Sepete eklenemedi', (err && (err.description || err.message)) || 'Lütfen tekrar deneyin.', true);
      })
      .finally(function () { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); });
  });
})();
